var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#0B4D4D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_922_218708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4095 16.845C16.026 16.2255 15.2595 15.585 15.2595 14.5875C15.2595 13.443 16.32 12.645 18.0945 12.645C19.9635 12.645 20.6565 13.5375 20.7195 14.85H23.04C22.9665 13.044 21.864 11.385 19.6695 10.8495V8.55H16.5195V10.818C14.4825 11.259 12.8445 12.582 12.8445 14.6085C12.8445 17.034 14.85 18.2415 17.7795 18.945C20.4045 19.575 20.9295 20.499 20.9295 21.4755C20.9295 22.2 20.415 23.355 18.0945 23.355C15.9315 23.355 15.081 22.389 14.9655 21.15H12.6555C12.7815 23.4495 14.5035 24.741 16.5195 25.1715V27.45H19.6695V25.1925C21.717 24.804 23.3445 23.6175 23.3445 21.465C23.3445 18.483 20.793 17.4645 18.4095 16.845Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_922_218708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.2,
    height: 25.2,
    fill: "white",
    transform: "translate(5.3999 5.4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/usd.862af4e9b7eb9d6e65620c4084fe9662.svg";
export { ForwardRef as ReactComponent };